import { msg } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import type { MessageDescriptor } from "@lingui/core";

import { recommendedActionText } from "../../i18n/enumText";
import { RECOMMENDED_ACTION_CODES } from "../../types";
import type { RecommendedActionCode } from "../../types";

const placeholder = msg`Выбери меру`;

export interface RecommendedActionSelectProps {
  value: RecommendedActionCode | "";
  ariaLabel: MessageDescriptor;
  onChange: (code: RecommendedActionCode) => void;
  disabled?: boolean;
  className?: string;
}

/** Dropdown of all recommended action codes (SSOT-driven), with a placeholder. */
export function RecommendedActionSelect({
  value,
  ariaLabel,
  onChange,
  disabled = false,
  className,
}: RecommendedActionSelectProps): JSX.Element {
  const { i18n } = useLingui();
  return (
    <select
      className={className}
      value={value}
      disabled={disabled}
      aria-label={i18n._(ariaLabel)}
      onChange={(event) => onChange(event.target.value as RecommendedActionCode)}
    >
      <option value="" disabled>
        {i18n._(placeholder)}
      </option>
      {RECOMMENDED_ACTION_CODES.map((code) => (
        <option key={code} value={code}>
          {i18n._(recommendedActionText(code))}
        </option>
      ))}
    </select>
  );
}
